import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const Visa = ()=>/*#__PURE__*/ _jsxs("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M13.9862 20.8007H11.5153L13.059 11.2036H15.53L13.9862 20.8007Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M9.43555 11.2034L7.07923 17.8055L6.79967 16.3829L5.96954 12.0587C5.91837 11.7919 5.76852 11.5549 5.55053 11.396C5.33254 11.2371 5.06282 11.1682 4.79635 11.2034H0.902485L0.855103 11.3654C1.76695 11.5966 2.63867 11.9669 3.44028 12.4636L5.58858 20.8006H8.16333L12.0942 11.2034H9.43555Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M28.8748 20.8039H31.1449L29.1667 11.2039H27.1766C26.9357 11.1857 26.6954 11.2456 26.4904 11.3748C26.2854 11.504 26.1265 11.6959 26.0366 11.9226L22.3512 20.8039H24.9288L25.4367 19.3789H28.5857L28.8748 20.8039ZM26.155 17.4092L27.4552 13.8156L28.1839 17.4092H26.155Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M22.5442 13.5122L22.8991 11.4582C22.185 11.1968 21.4341 11.0529 20.6749 11.0317C19.4482 11.0317 16.5356 11.5736 16.5356 14.2108C16.5356 16.6913 19.9538 16.722 19.9538 18.0243C19.9538 19.3266 16.8886 19.0923 15.8756 18.2811L15.5074 20.4228C16.3918 20.7985 17.3439 20.9839 18.303 20.9671C19.9893 20.9671 22.5338 20.0836 22.5338 17.6803C22.5338 15.1844 19.0853 14.9492 19.0853 13.8668C19.0853 12.7844 21.4876 12.9215 22.5442 13.5122Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M6.79967 16.3853L5.96954 12.0587C5.91837 11.7919 5.76852 11.5549 5.55053 11.396C5.33254 11.2371 5.06282 11.1682 4.79635 11.2034H0.902485L0.855103 11.3654C2.19657 11.7112 3.44826 12.3462 4.52438 13.2268C5.54555 14.0576 6.33133 15.1475 6.79967 16.3853Z",
                fill: "currentColor"
            })
        ]
    });
export const MasterCard = ()=>/*#__PURE__*/ _jsxs("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M19.2465 10.5332H12.7578V21.8015H19.2465V10.5332Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M13.1672 16.168C13.1675 15.084 13.4215 14.0141 13.9102 13.0384C14.3989 12.0627 15.1097 11.2065 15.9894 10.5339C15.0597 9.82888 13.9692 9.3489 12.8086 9.13393C11.6481 8.91896 10.4512 8.97523 9.31774 9.29805C8.18427 9.62087 7.14707 10.2009 6.29261 10.9897C5.43815 11.7786 4.79118 12.7534 4.40565 13.833C4.02012 14.9125 3.9072 16.0655 4.0763 17.1958C4.24539 18.326 4.69161 19.4009 5.37774 20.3307C6.06388 21.2604 6.97005 22.0182 8.02072 22.5409C9.07138 23.0635 10.2361 23.3358 11.4178 23.3351C13.0767 23.336 14.6874 22.7959 15.9894 21.8022C15.108 21.1311 14.396 20.2752 13.9071 19.2991C13.4182 18.3231 13.1652 17.2524 13.1672 16.168V16.168Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M28.0008 16.1676C28.0024 17.512 27.6123 18.8297 26.8751 19.9698C26.1379 21.11 25.0834 22.0264 23.8324 22.6143C22.5814 23.2022 21.1844 23.4378 19.8013 23.2941C18.4181 23.1504 17.1049 22.6332 16.0117 21.8017C16.8915 21.1293 17.6024 20.2731 18.0912 19.2974C18.5799 18.3216 18.8338 17.2516 18.8338 16.1676C18.8338 15.0835 18.5799 14.0135 18.0912 13.0378C17.6024 12.062 16.8915 11.2058 16.0117 10.5334C17.1049 9.70193 18.4181 9.18473 19.8013 9.04102C21.1844 8.89731 22.5814 9.1329 23.8324 9.72081C25.0834 10.3087 26.1379 11.2252 26.8751 12.3653C27.6123 13.5054 28.0024 14.8231 28.0008 16.1676V16.1676Z",
                fill: "currentColor"
            })
        ]
    });
